// const baseUrl = "https://prod.baas.batterypool.com";
const baseUrl = "https://test.baas.batterypool.com";
const baseTestUrl = "https://test.baas.batterypool.com";

export const endpoints = {
  driver: {
    ids: `${baseUrl}/driver/api/drivers/getListOfDriverIds`,
    details: (driverId, partnerId) =>
      `${baseUrl}/driver/api/getDriverDetailsProxy/${driverId}?partnerId=${partnerId}`,
  },
  partner: {
    ids: `${baseUrl}/general/api/partners/getListOfPartnerIdsWithDetails`,
    details: (partnerId) => `${baseUrl}/general/api/partners/${partnerId}`,
    billStatus: (partnerId) =>
      `${baseUrl}/general/api/partners/partnerBillStatusProxy/${partnerId}`,
  },
  device: {
    ids: `${baseUrl}/general/api/general/getDeviceIds`,
  },
  battery: {
    ids: `${baseUrl}/battery/api/batteries/getListOfBatteries`,
    initiateBatteryMovement: `${baseTestUrl}/battery/api/initiateBatteryMovement`,
    initiateBatteryMovementV2: `${baseTestUrl}/battery/api/v2/initiateBatteryMovement`,
    updateBatteryMovementStatus: `${baseTestUrl}/battery/api/updateBatteryMovementStatus`,
    updateBatteryMovement: `${baseTestUrl}/battery/api/updateBatteryMovement`,
    getBatteryMovements: `${baseTestUrl}/battery/api/getBatteryMovements`,
  },
  general: {
    getStateNames: `${baseTestUrl}/general/api/getStateNames`,
  },
  manualSwap: {
    addManualSwap: `${baseUrl}/swap/swap/v2/addManualSwap`,
    otaPost: `${baseTestUrl}/swap/swap/createTransactionTestLocal`,
    getSwapLogsBaas: `${baseTestUrl}/general/api/general/getSwapLogsBaas`,
  },
  cashCollection: {
    post: `${baseUrl}/payments/payment/createCashCollectionEntry`,
  },
  registerCashCollection: {
    post: `${baseUrl}/payments/payment/registerCashCollection`,
  },
  walletTopUp: {
    post: `${baseUrl}/payments/payment/walletTopUp`,
  },
  openDoorCommand: {
    post: `${baseUrl}/iot/iot/openDoorCommand`,
  },
};
